<template>
  <div ref="msg" :style="{ color: color }" class="cc-form-msg-fire">
    <div class="inner-part">
      <div :style="{ backgroundColor: color, ...bgStyle }" class="bg"></div>
      <i class="icon iconfont icona-huo211"></i>
      <div>{{ countOptions.prefix }}</div>
      <div :style="{ backgroundColor: color }" class="number">
        {{ countOptions.count }}
      </div>
      <div>{{ countOptions.suffix }}</div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'CountFire',
  mixins: [mixin],
  props: {
    countOptions: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
.cc-form-msg-fire {
  position: relative;
  margin-top: 12px;
  margin-bottom: 2px;
  display: inline-block;
  max-width: 100%;
  .inner-part {
    position: relative;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    .bg {
      position: absolute;
      border-radius: 6px;
      opacity: 0.06;
      left: 0;
    }
    i {
      margin-right: 5px;
    }
    .number {
      border-radius: 4px;
      line-height: 22px;
      font-size: 12px;
      padding: 0 6px;
      margin: 0 4px;
      color: white;
    }
  }
}
</style>
